import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postHealthFamilyDetailSlice = createSlice({
  name: "postHealthFamilyDetail",
  initialState,
  reducers: {
    postHealthFamilyDetailStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postHealthFamilyDetailSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
      console.log(action.payload, "<=====action.payload");
    },
    postHealthFamilyDetailFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postHealthFamilyDetailStart,
  postHealthFamilyDetailSuccess,
  postHealthFamilyDetailFailure,
  clearError,
  clearMessage,
} = postHealthFamilyDetailSlice.actions;

export default postHealthFamilyDetailSlice.reducer;
